﻿﻿export interface ICenterNotificationRequest {
    id: number;
    centerId: number;
    isEnabled: boolean;
    description: string;
    notificationText: string;
}
